import { Pipe, PipeTransform } from '@angular/core';

import { EdesignConstants } from '../../shared/models/edesignConstants';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { DeviceImageConstants } from '../constants/device-image.constants';

@Pipe({
    name: 'catalogProductImage',
    standalone: false
})
export class CatalogProductImagePipe implements PipeTransform {
  constructor(private readonly configurationService: ConfigurationService) {}
  url = this.configurationService.getProductImageUrl();

  getUrl(reference: string, isNsxDummy: boolean, isCustomDevice?: boolean): string {
    let url = this.url;
    if (isCustomDevice && !isNsxDummy) {
      return DeviceImageConstants.DEFAULT_IMAGE;
    }

    switch (reference) {

      case 'CH2EBIC25A':
        url = '/assets/images/CH2EBIC25A.PNG';
        return url;
      case 'Cxxxxxxx':
        url = '/assets/images/Custom_device_3d.PNG';
        return url;
      case 'NCxxxxxx':
        url = '/assets/images/Custom_device_3d.PNG';
        return url;
      case 'NXxxxxxx':
        url = '/assets/images/NSX_Dummy_3d.PNG';
        return url;
      case 'NX4P4063xxxx':
        url = '/assets/images/NSX_Dummy_3d_4P_400-630.PNG';
        return url;
      case 'NX4P1025xxxx':
        url = '/assets/images/NSX_Dummy_3d_4P_100-250.PNG';
        return url;
      case 'NX4063xxxxxx':
        url = '/assets/images/NSX_Dummy_3d_400-630.PNG';
        return url;
      case 'A9N17973':
        url = '/assets/images/A9N19773.PNG';
        return url;
      case '87003.FLF.SET.61':
        url = 'https://mam.feller.ch/pict/87003.FLF.SET.61?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '87003.FLF.SET.B.61':
        url = 'https://mam.feller.ch/pict/87003.FLF.SET.B.61?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-118.U.REG':
        url = 'https://mam.feller.ch/pict/1180-118.U.REG?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-000.REG':
        url = 'https://mam.feller.ch/pict/1180-000.REG?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-118.S.REG':
        url = 'https://mam.feller.ch/pict/1180-118.S.REG?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-118.C6AU.REG':
        url = 'https://mam.feller.ch/pict/1180-118.C6AU.REG?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-HE116U':
      case '1180-HE216U':
      case '1180-HE204U':
      case '1180-HE200':
      case '1180-HE100':
      case '1180-1.C6U':
      case '1180-1.C6AU':
      case '1180-1.C6AS':
      case '1180-HE324U':
      case '1180-HE324ERD':
      case '1180-KP500.C6AS':
      case '1180-KP300.C6U':
      case '1180-PC050.C6U':
      case '1180-PC100.C6U':
      case '1180-PC200.C6U':
      case '1180-PC300.C6U':
      case '1180-PC500.C6U':
      case '1180-PC1000.C6U':
        url = 'https://mam.feller.ch/pict/' + reference + '?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-100.C6U':
        return 'https://online-katalog.feller.ch/pict/FEG/FEG_1180-1.C6U.PNG';
      case '1180-100.C6AU':
        return 'https://online-katalog.feller.ch/pict/FEG/FEG_1180-1.C6AU.PNG';
      case '1180-100.C6AS':
        return 'https://online-katalog.feller.ch/pict/FEG/FEG_1180-1.C6AS.PNG';
      case '1180-PC100.C6AS':
      case '1180-PC200.C6AS':
      case '1180-PC300.C6AS':
      case '1180-PC500.C6AS':
      case '1180-PC1000.C6AS':
        return 'https://online-katalog.feller.ch/pict/FEG/FEG_1180-PC1000.C6U.PNG';
      case '1180-HE116S':
        url = 'https://mam.feller.ch/pict/1180-HE116S?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case '1180-HE110':
        url = 'https://online-katalog.feller.ch/pict/FEG/FEG_1180-HE100.PNG';
        return url;
      case '2211-40FLF':
        url = 'https://online-katalog.feller.ch/pict/FEG/FEG_2211-40.FLF.PNG';
        return url;
      case '87003FLFSET61':
        url = 'https://online-katalog.feller.ch/pict/FEG/FEG_87003.FLF.SET.61.PNG';
        return url;
      case '2211-40.FLF':
        url = 'https://mam.feller.ch/pict/2211-40.FLF?type=png&width=500&height=500&fit=contain&margin=10';
        return url;
      case 'A9P52713':
        return url.replace('{reference}', 'A9P54716');
      default:
        if (isNsxDummy) {
          url = '/assets/images/NSX_Dummy_3d.PNG';
          return url;
        }
        if (EdesignConstants.SNC_NO_PRODUCT_IMAGE.indexOf(reference) > -1) {
          url = '/assets/images/product-images/' + reference + '.PNG';
          return url;
        } else {
          return url.replace('{reference}', reference);
        }
    }
  }

  transform(reference: string, isNsxDummy: boolean, isCustomDevice?: boolean): Promise<string> {
    return new Promise<string>((resolve) => {
      let errorHandled = false;

      const img = new Image();
      img.src = this.getUrl(reference, isNsxDummy, isCustomDevice);
      img.onload = () => resolve(img.src);
      img.onerror = () => {
        if (!errorHandled) {
          errorHandled = true;
          this.url = this.configurationService.getProductImageBackupUrl();
          resolve(this.getUrl(reference, isNsxDummy, isCustomDevice));
        }
      };
    });
  }
}
